module.exports = __webpack_public_path__ + "static/badge1-0190f43d8d9474a0f49c764f22900ae6.svg";